import {
  useCallback, useState 
} from "react"

export const usePassword = () => {
  const [visible, setVisbility] = useState(false)

  const togglePasswordVisibility = useCallback(() => {
    setVisbility(!visible)
  }, [visible])

  const handleBlur = useCallback(() => {
    setVisbility(false)
  }, [])

  return {
    handleBlur,
    togglePasswordVisibility,
    visible,
  }
}
